/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  CharityListView,
  UtxCharityApiGetAllCharitysParams
} from './schema'



export const utxCharityApiGetAllCharitys = (
    params?: UtxCharityApiGetAllCharitysParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CharityListView[]>> => {
    return axios.get(
      `/charity/list`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxCharityApiGetAllCharitysQueryKey = (params?: UtxCharityApiGetAllCharitysParams,) => [`/charity/list`, ...(params ? [params]: [])];

    
export type UtxCharityApiGetAllCharitysQueryResult = NonNullable<Awaited<ReturnType<typeof utxCharityApiGetAllCharitys>>>
export type UtxCharityApiGetAllCharitysQueryError = AxiosError<unknown>

export const useUtxCharityApiGetAllCharitys = <TData = Awaited<ReturnType<typeof utxCharityApiGetAllCharitys>>, TError = AxiosError<unknown>>(
 params?: UtxCharityApiGetAllCharitysParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCharityApiGetAllCharitys>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCharityApiGetAllCharitysQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCharityApiGetAllCharitys>>> = ({ signal }) => utxCharityApiGetAllCharitys(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCharityApiGetAllCharitys>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

